import React, { Component } from 'react';
//import OriginPopconfirm from 'bee-popconfirm';
import { Popconfirm as OriginPopconfirm } from '@tinper/next-ui';
import { getLangCode, getMultiLang, getSysFieldid, microAppUtil } from '@platform/api';
import Button from '../Button';
import HotKeys from '../HotKeys';
import Tooltip from '../Tooltip';

require('./index.less');

const langCode = getLangCode();
export default class Popconfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            LangData: null,
        };
        this.uuid = 'pop_' + (new Date().getTime());
        this.defaultBody = microAppUtil.getDocument();
    }

    content = (
        <span>
            您确认删除此业务吗？
        </span>
    );

    getPopupContainer = () => {
        const { getDocument } = microAppUtil;
        return getDocument();
    }

    componentWillMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'container_toast', callback });
    }

    render() {
        let { json } = this.state;
        let { onCancel, onClose, className, getPopupContainer, ...others } = this.props;
        let confirm = json['0005'] || '确定';
        let cancel = json['0006'] || '取消';
        return (
            <HotKeys
                keyMap={{
                    sureBtnHandler: [HotKeys.USUAL_KEYS.MODAL_CONFIRM[0], 'enter'],
                    cancelBtnHandler: [HotKeys.USUAL_KEYS.MODAL_CANCEL[0], 'esc'],
                }}
                handlers={{
                    sureBtnHandler: e => {
                        // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                        // let confirm = this.Popconfirm || this;
                        let confirm = this.defaultBody.querySelector(`.${this.uuid}`);
                        if (confirm) {
                            // confirm.handleClose(e);
                            let btn = confirm.querySelector('.pop-sure-btn');
                            btn && btn.click();
                        }
                    },
                    cancelBtnHandler: e => {
                        // 取消按钮的事件  增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                        // let confirm = this.Popconfirm || this;
                        let confirm = this.defaultBody.querySelector(`.${this.uuid}`);
                        if (confirm) {
                            // confirm.handleCancel(e);
                            let btn = confirm.querySelector('.pop-cancel-btn');
                            btn && btn.click();
                        }
                    },
                }}
                className="popconfirm-hotkeys-wrapper "
                display="inline"
                focused={true}
            // attach={false}
            >
                <OriginPopconfirm
                    content={this.content}
                    rootClose={true}
                    // 增加ref对象 用于父调用子方法 bbqin
                    ref={popconfirm => (this.Popconfirm = popconfirm)}
                    {...others}
                    fieldid={getSysFieldid("tips-window")}
                    overlayClassName={`nc-popconfirm ${this.uuid} ${className}`}
                    id={this.uuid}
                    stopbubble={1}
                    getPopupContainer = { getPopupContainer ? getPopupContainer : this.getPopupContainer }
                    locale={{
                        lang: langCode,
                        ok: confirm,
                        cancel,
                    }}
                    // icon={null}
                    cancel_btn={
                        <Button size="sm" style={{ minWidth: 50 }} colors="primary" fieldid="confirm" className="pop-sure-btn">
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${confirm}  (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                                trigger={['hover', 'focus']}
                                overlayClassName="popover-use-tooltip"
                            >
                                <span>
                                    {confirm}(
                                    <span className="text-decoration-underline">Y</span>
                                    )
                                </span>
                            </Tooltip>
                        </Button>
                    }
                    close_btn={
                        <Button
                            size="sm"
                            style={{ minWidth: 50 }}
                            shape="border" // border  info
                            fieldid="cancel"
                            className="pop-cancel-btn"
                        >
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${cancel}  (${HotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                                trigger={['hover', 'focus']}
                                overlayClassName="popover-use-tooltip"
                            >
                                <span>
                                    {cancel}(
                                    <span className="text-decoration-underline">N</span>
                                    )
                                </span>
                            </Tooltip>
                        </Button>
                    }
                    onClose={onCancel}
                    onCancel={onClose}
                />
            </HotKeys>
        );
    }
}
